import { render, staticRenderFns } from "./listaGrupos.vue?vue&type=template&id=af153fe6"
import script from "./listaGrupos.vue?vue&type=script&lang=js"
export * from "./listaGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports